import { render } from "./PageIdeaForm.vue?vue&type=template&id=21060852&scoped=true"
import script from "./PageIdeaForm.vue?vue&type=script&lang=js"
export * from "./PageIdeaForm.vue?vue&type=script&lang=js"

import "./PageIdeaForm.vue?vue&type=style&index=0&id=21060852&lang=scss&scoped=true"

import exportComponent from "/Users/simonkravec/weby/zmen-form/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21060852"]])

export default __exports__